"use strict";
module.exports = {
    domain: 'fadhilamadan.com',
    siteUrl: 'https://fadhilamadan.com',
    dashboardUrl: 'https://datocms.fadhilamadan.com'
};
